import axios from "axios";
import { getSessionId } from "../../../../../utils/tokenHandlers";
export const updateMasterAgreement = (customerId: number, docId: number) => {
  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer/${customerId}`,
      {
        params: {
          context: {},
          data: {
            master_agreeement_attachment_ids: [docId],
          },
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((err) => err);
};
